module.exports = __webpack_public_path__ + "static/media/lazarusAI2.1acefe36.png";